<template>
  <div class="h5-upload clear ">
    <van-uploader
      v-model="fileList"
      :after-read="afterRead"
      :max-count="maxCount"
      :before-delete="deleteImg"
      capture="camera"
    >
      <div class="uploader">
        <div class="img-tips">
          <img :src="require('@/assets/PC/img/plus@2x.png')" alt="" />
        </div>
<!--        <div class="desc">{{$t('other.clickTakePhoto')}}</div>-->
        <div class="desc">{{ $t('pc.upload') }}</div>
      </div>
    </van-uploader>

     <van-image-preview v-model="show" :images="images"></van-image-preview>
  </div>


</template>

<script>
export default {
  name: "h5Upload",
  props: {
    maxCount: {
      type: Number,
      default: 1,
    },
    keyValue: {
      type: String,
      default: "",
    },
    id: {
      type:[Number, String],
      default:0
    },
    staticSmallImg_mutiOneCase: {
      type: String,
      default: '',
    },
    staticBigImg_mutiOneCase: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      images:null,
      show: false,
      fileList: [],
      _fileList: []
    }
  },
  methods: {
    // 预览图片
    showViewImage(img){
      this.show = true
      this.images = Array.isArray(img) ? img : [img]
    },
    afterRead(file,name) {
      file.status = 'uploading'
      file.message = this.$t('upload.uploading')
      const params = {
        file: file.file,
        key: this.keyValue,
        photoIndex:name.index
      };
      // 上传结束后的回调 YH000541
      params.uploadCallback = (res) => {
        if(res){
          file.status = 'done'
          file.message = '上传成功'
        }else{
          file.status = 'failed'
          file.message = this.$t('upload.uploadFail')
        }
      }

      this.$emit("afterRead", params);
    },
    deleteImg(file, name){
    //标识, 使用的商品的索引
      const photoIndex = name.index
      const params = {
        key: this.keyValue,
        photoIndex,
        id:this.id
      };
      this.$emit('delete',params)
      return true
    },
    deleteImg_mutiOneCase(photoIndex){
      const params = {
        key: this.keyValue,
        photoIndex,
        id:this.id
      };
      this.fileList.splice(photoIndex, 1)
      console.log(params)
      this.$emit('delete',params)
      return true
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .staticSmallImg_mutiOneCase .van-uploader__preview{
  display: none;
}
  .img-item-staticBigImg_mutiOneCase {
    margin-bottom: 9px;
    width: 150px;
    // display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .img-item-staticBigImg_mutiOneCase:nth-child(2n+1){
    margin-right: 20px;
  }
  .img-item-0{
    margin-bottom: 0;
  }
.uploader {
  width: 150px;
  height: 150px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .img-tips {
    width: 40px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .desc {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
  }
}

.h5-upload {
  & /deep/ .van-uploader__wrapper{
      flex-wrap: wrap;
      margin-right:0;
    }
  & /deep/ .van-uploader {
    .van-uploader__preview {
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right:0;
      margin-bottom:0;
    }

    .van-image {
      width: 200px;
      height: 200px;
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .van-uploader__preview:nth-child(2n+1) {
      // margin-right: 20px;
    }
    .van-uploader__input-wrapper{
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right:0;
    }

  }


}

  .uploader{
    display: flex;
    justify-content: center;
    align-items: center
  }
  .h5-upload.clear{
    // background: #f2f2f2 !important;
    //width: 150px;
    // height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ div {
    .van-uploader__input-wrapper{
      width: 200px !important;
      height: 200px !important;
      display: flex;
      justify-content: center !important;
      align-items: center;
      background: #f2f2f2;
      .uploader{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .img-tips{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0;
        img{
          margin-right: 0;
        }
      }
    }
  }
  /deep/ .van-uploader__preview-delete {
    width: 40px;
    height: 40px;
    border-radius: 0 0 0 40px;
  }
  /deep/ .van-uploader__preview-delete-icon::before {
    width: 20px;
    height: 20px;
    font-size: 20px !important;
  }
  /deep/ .van-uploader__preview-delete-icon {
    top: 6px;
    right: 6px;
  }
</style>
